import PropTypes from 'prop-types';

import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';

import useStyles from './styles';

function TooltipChart({ children }) {
  const theme = useTheme();
  const clasess = useStyles();

  return (
    <>
      <Box className={clasess.baseTootlip}>{children}</Box>
      <Box
        bgcolor="background.paper"
        borderBottom={`1px solid ${theme.palette.darkGrey[15]}`}
        borderRadius="1px"
        borderRight={`1px solid ${theme.palette.darkGrey[15]}`}
        height="12px"
        margin="auto"
        mt="-7px"
        sx={{ transform: 'rotate(45deg)', zIndex: '-1' }}
        width="12px"
      />
    </>
  );
}

TooltipChart.propTypes = {
  children: PropTypes.node,
};

export default TooltipChart;
